import React from "react";

export default function Footer() {
  return (
    <div className="footer">
      <small>
        <a
          href="https://github.com/madtos12/react-weather-app"
          target="_blank"
          rel="noreferrer"
        >
          Open-source code
        </a>{" "}
        by Madeline Santos
      </small>
    </div>
  );
}
